var UserService = (function () {
        var changePassword = false;

        function editAvatar() {
            var formData = new FormData();
            //заменить id на класс
            var file = $('.js-upload-avatar:file')[0].files[0];
            var isRemove = $('.js-up-remove-avatar').val();
            if (file !== undefined) {
                formData.append('avatar', file);
            }
            if (isRemove !== undefined && file !== undefined) {
                formData.append('isRemove', isRemove);
            }
            if (file === undefined) {
                isRemove = true;
                formData.append('isRemove', isRemove);
            }
            $.ajax({
                url: '/user/profile/avatar/update',
                data: formData,
                processData: false,
                contentType: false,
                type: 'POST',
                success: function () {
                    location.reload();
                },
                error: function () {
                }
            });
        }

        function profileEditSubmit() {

            if ($('main.content').attr('data-general-tab') == 'profile') {
                var firstName = $('.js-input-profile-edit-first-name'),
                    phone = $('.js-input-profile-edit-phone'),
                    currentPassword = $('.js-input-profile-edit-currentPassword'),
                    password = $('.js-input-profile-edit-password'),
                    lastName = $('.js-input-profile-edit-last-name'),
                    secondName = $('.js-input-profile-edit-second-name'),
                    sexType = $('.js-input-profile-edit-sex-type'),
                    maritalStatusType = $('.js-input-profile-edit-marital-status'),
                    birthday = $('.js-input-profile-edit-birthday'),
                    monthOfBirth = $('.js-input-profile-edit-monthOfBirth'),
                    yearOfBirth = $('.js-input-profile-edit-yearOfBirth'),
                    cityId = $('.js-input-profile-edit-cityId'),
                    emailInfo = $('.js-input-profile-edit-emailinfo'),
                    email = $('.js-input-profile-edit-email');

                $('.has-error').removeClass('has-error');
                $('.help-block').remove();
                var isValid = true;

                if (firstName.length > 0 && firstName.val().length < 2) {
                    isValid = false;
                    AppService.displayError('Обязательное поле', firstName);
                }

                var strPhone = '';
                if (phone.length > 0) {
                    strPhone = phone.val().split('+').join('').split(' ').join('').split('-').join('').split('_').join('');
                }


                $('.has-error').removeClass('has-error');
                $('.help-block').remove();
                var isValid = true;

                if (firstName.val().length < 2) {
                    isValid = false;
                    AppService.displayError('Обязательное поле', firstName);
                }

                var strPhone = phone.val().split('+').join('').split(' ').join('').split('-').join('').split('_').join('');

                if (strPhone.length < 11) {
                    isValid = false;
                    AppService.displayError('Некорректный номер телефона', phone);
                }

                if (changePassword) {
                    if (currentPassword.val().length < 6) {
                        isValid = false;
                        AppService.displayError('Пароль не может быть меньше 6 символов', currentPassword);
                    }

                    if (password.val().length < 6) {
                        isValid = false;
                        AppService.displayError('Пароль не может быть меньше 6 символов', password);
                    } else if (password.val() === currentPassword.val()) {
                        isValid = false;
                        AppService.displayError('Новый и старый пароль совпадают', password);
                    }
                }

                if (isValid) {
                    var data = {
                        firstName: firstName.val(),
                        phone: phone.val(),
                        currentPassword: currentPassword.val(),
                        password: password.val(),
                        lastName: lastName.val(),
                        secondName: secondName.val(),
                        sexType: sexType.val(),
                        maritalStatusType: maritalStatusType.val(),
                        dayOfBirth: birthday.val(),
                        monthOfBirth: monthOfBirth.val(),
                        yearOfBirth: yearOfBirth.val(),
                        cityId: cityId.val(),
                        emailInfo: emailInfo.val(),
                        email: email.val()
                    };

                    $.ajax({
                        url: '/user/profile',
                        data: data,
                        type: 'POST',
                        success: function (response) {
                            if (response === 'CONTINUE') {
                                $(function () {
                                    $("#tabs li:eq(1) a").tab('show');
                                });
                                if (document.referrer.indexOf("/loyalty/intro") !== -1) {
                                    LoyaltyService.sendGoogleAnalyticsEventOnCondition(5, true);
                                }
                            } else if (response == 'OK') {
                                location.reload();
                            }
                        },
                        error: function () {
                        }
                    });
                }
            }
            return false;
        }

        function checkChangePassword() {
            if (!changePassword) {
                $('.js-input-profile-edit-currentPassword').val('********');
                $('.js-input-profile-edit-currentPassword').prop('readonly', true);
                $('.js-up-change-password').text('Изменить');
                $('.js-input-profile-edit-password').val('');
                $('.js-input-profile-edit-password-row').hide();
                // profileEditSubmit();
            } else {
                $('.js-input-profile-edit-currentPassword').val('');
                $('.js-input-profile-edit-currentPassword').prop('readonly', false);
                $('.js-up-change-password').text('Скрыть');
                $('.js-input-profile-edit-password-row').show();
            }
        }

        function showRollForAcquaintanceModal() {
            var element = $('.up-avatar');
            var fullness = element.data('fullness-profile');
            if (fullness === 100 && $('main.content').attr('data-general-tab') == 'profile') {
                $('.modal.in').modal('hide');
                $('#availabilityRollForAcquaintanceModal').modal('show');
            }
        }

        function unwrapUndefined(el) {
            if (el === undefined || el.val() === undefined) {
                return "";
            } else {
                return  el.val();
            }
        }

        let addAddressStreet = {value: false, change: refreshAddButton};
        let addAddressHouse = {value: false, change: refreshAddButton};
        let editAddressStreet = {value: false, change: refreshEditButton};
        let editAddressHouse = {value: false, change: refreshEditButton};

        function refreshAddButton(element, showError) {
            let button = $('.js-lk-address-add-button');
            let disabled;
            disabled = !(addAddressStreet.value && addAddressHouse.value);

            button.prop("disabled", disabled);

            showOrDeleteError(element, showError);
        }

        function showOrDeleteError(element, showError) {
            if (showError) {
                AppService.displayError("Пожалуйста, выберите элемент из списка", element);
            } else {
                AppService.deleteError(element)
            }
        }

        function refreshEditButton(element, showError) {
            let button = $('.js-lk-address-edit-button');
            let disabled;
            disabled = !(editAddressStreet.value && editAddressHouse.value);

            button.prop("disabled", disabled);

            showOrDeleteError(element, showError);
        }

        function init() {


            let streetAddress = $("#js-add-address-street");
            if (streetAddress.length) {
                streetAddress.autoComplete({
                    minChars: 2,
                    source: function (request, response) {
                        $.ajax({
                            method: 'GET',
                            url: "/api/v7/addressResolver/suggestions/street?query=" + request + "&cityId=" + $('.js-current-cityId').val(),
                            success: function (data) {
                                response($.map(data.items, function (item) {
                                    var arr = [item.suggestion.value, item.suggestion.streetKladrId];
                                    return {
                                        arr
                                    }
                                }));
                            }
                        });
                    },
                    renderItem: function (item, search) {
                        search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                        var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
                        return '<div class="autocomplete-suggestion" data-val="' + item.arr[0] + '" data-street-kladr-id="' + item.arr[1] + '">' + item.arr[0].replace(re, "<b>$1</b>") + '</div>';
                    }
                });
                AppService.onlyAutoCompleteListElement(streetAddress, $('.js-add-address-street-kladr-id'), 'street-kladr-id', addAddressStreet);
            }
            let houseAddress = $("#js-add-address-house");
            if (houseAddress.length) {
                houseAddress.autoComplete({
                    minChars: 1,
                    source: function (request, response) {
                        $.ajax({
                            method: 'GET',
                            url: "/api/v7/addressResolver/suggestions/house?query=" + request + "&streetKladrId=" + unwrapUndefined($('.js-add-address-street-kladr-id')) + "&cityId=" + $('.js-current-cityId').val(),
                            success: function (data) {
                                response($.map(data.items, function (item) {
                                    var arr = [item.suggestion.value, item.suggestion.houseKladrId];
                                    return {
                                        arr
                                    }
                                }));
                            }
                        });
                    },
                    renderItem: function (item, search) {
                        search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                        var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
                        return '<div class="autocomplete-suggestion" data-val="' + item.arr[0] + '" data-house-kladr-id="' + item.arr[1] + '">' + item.arr[0].replace(re, "<b>$1</b>") + '</div>';
                    },
                    onSelect: function (e, term, item) {
                        $.ajax({
                            method: 'GET',
                            url: "/api/v7/addressResolver/suggestions/house?query=" + term + "&streetKladrId=" + $('.js-add-address-street-kladr-id').val() + "&cityId=" + $('.js-current-cityId').val() + "&suggestionsCount=1",
                            success: function (data) {
                                if (data.items.length !== 0) {
                                    $('.js-add-address-lat').val(data.items[0].suggestion.lat);
                                    $('.js-add-address-lon').val(data.items[0].suggestion.lon);
                                }
                            }
                        });
                    }
                });
                AppService.onlyAutoCompleteListElement(houseAddress, $('.js-add-address-house-kladr-id'), 'house-kladr-id', addAddressHouse);
            }

            let editAddressStreetElement = $("#js-edit-address-street");

            if (editAddressStreetElement.length) {
                editAddressStreetElement.autoComplete({
                    minChars: 2,
                    source: function (request, response) {
                        $.ajax({
                            method: 'GET',
                            url: "/api/v7/addressResolver/suggestions/street?query=" + request + "&cityId=" + $('.js-current-cityId').val(),
                            success: function (data) {
                                response($.map(data.items, function (item) {
                                    var arr = [item.suggestion.value, item.suggestion.streetKladrId];
                                    return {
                                        arr
                                    }
                                }));
                            }
                        });
                    },
                    renderItem: function (item, search) {
                        search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                        var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
                        return '<div class="autocomplete-suggestion" data-val="' + item.arr[0] + '" data-street-kladr-id="' + item.arr[1] + '">' + item.arr[0].replace(re, "<b>$1</b>") + '</div>';
                    }
                });
                AppService.onlyAutoCompleteListElement(editAddressStreetElement, $('.js-edit-address-street-kladr-id'), 'street-kladr-id',editAddressStreet);
            }

            let editAddressHomeElement = $("#js-edit-address-house");

            if (editAddressHomeElement.length) {
                editAddressHomeElement.autoComplete({
                    minChars: 1,
                    source: function (request, response) {
                        $.ajax({
                            method: 'GET',
                            url: "/api/v7/addressResolver/suggestions/house?query=" + request + "&streetKladrId=" + unwrapUndefined($('.js-edit-address-street-kladr-id')) + "&cityId=" + $('.js-current-cityId').val(),
                            success: function (data) {
                                response($.map(data.items, function (item) {
                                    var arr = [item.suggestion.value, item.suggestion.houseKladrId];
                                    return {
                                        arr
                                    }
                                }));
                            }
                        });
                    },
                    renderItem: function (item, search) {
                        search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                        var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
                        return '<div class="autocomplete-suggestion" data-val="' + item.arr[0] + '" data-house-kladr-id="' + item.arr[1] + '">' + item.arr[0].replace(re, "<b>$1</b>") + '</div>';
                    },
                    onSelect: function (e, term, item) {
                        $.ajax({
                            method: 'GET',
                            url: "/api/v7/addressResolver/suggestions/house?query=" + term + "&streetKladrId=" + $('.js-edit-address-street-kladr-id').val() + "&cityId=" + $('.js-current-cityId').val() + "&suggestionsCount=1",
                            success: function (data) {
                                if (data.items.length !== 0) {
                                    $('.js-edit-address-lat').val(data.items[0].suggestion.lat);
                                    $('.js-edit-address-lon').val(data.items[0].suggestion.lon);
                                }
                            }
                        });
                    }
                });

                AppService.onlyAutoCompleteListElement(editAddressHomeElement, $('.js-edit-address-house-kladr-id'), 'house-kladr-id',editAddressHouse);
            }

            $('#modalProfileAddressAdd').on('shown.bs.modal', function (e) {
                if (document.referrer.indexOf("/loyalty/intro") !== -1) {
                    LoyaltyService.sendGoogleAnalyticsEventOnCondition(6, true);
                }
            });

            $('#js-user-profile-add-address-form').submit(function () {
                if (document.referrer.indexOf("/loyalty/intro") !== -1) {
                    LoyaltyService.sendGoogleAnalyticsEventOnCondition(7, true);
                }
            });

            $('.js-input-profile-confirmed-phone-alert').click(function () {
                $('.modal.in').modal('hide');
                $('#confirmedPhoneAlert').modal('show');
            });

            $('.js-confirm-phone-alert-to-guest-book').click(function () {
                $('#confirmedPhoneAlert').modal('hide');
                AppService.redirectTo("/guestbook")
            });

            changePassword = $('.js-up-change-password').data('change-password');

            $('.js-upload-avatar').change(editAvatar);
            checkChangePassword();
            $('.up-avatar').find('.js-remove-avatar').click(editAvatar);

            $('.js-roll-for-acquaintance-modal-show').click(showRollForAcquaintanceModal);

            var profileAddAddressForm = $('#js-user-profile-add-address-form');
            if (profileAddAddressForm.length > 0) {
                var street = $('#js-add-address-street');
                var house = $('#js-add-address-house');
                profileAddAddressForm.submit(function () {

                    var isValid = true;

                    if (/*city.val() == '' ||*/ street.val() == '' || house.val() == '') {
                        isValid = false;
                        AppService.displayError('Укажите полный адрес', /*input*/ street);
                    }

                    if (!isValid) {
                        return false;
                    }
                });
            }

            $('.js-up-profile-submit').click(profileEditSubmit);

            $('.js-repeat-order').click(function () {
                BasketService.requestRepeatOrder(
                    $(this).data('number'), AnimationsService.animate.basket
                );
            });

            $('.js-user-profile-address-edit').click(function () {
                var $this = $(this);
                $('#js-edit-address-id').val($this.data('id'));
                $('#js-edit-address-title').val($this.data('title'));
                $('#js-edit-address-street').val($this.data('street'));
                $('#js-edit-address-house').val($this.data('house'));
                $('#js-edit-address-flat').val($this.data('flat'));
                $('#js-edit-address-housing').val($this.data('housing'));
                $('#js-edit-address-entrance').val($this.data('entrance'));
                $('#js-edit-address-floor').val($this.data('floor'));

                $('.modal.in').modal('hide');
                $('#modalProfileAddressEdit').modal('show');
            });

            $('.js-user-profile-address-item-remove-link').click(function () {
                var $this = $(this);
                $('#js-modal-profile-address-remove-accept').prop('href', $this.data('href'));

                $('.modal.in').modal('hide');
                $('#modalProfileAddressRemove').modal('show');
            });

            $('.js-up-change-password').click(function () {
                changePassword = !changePassword;
                checkChangePassword();
            });
        }

        return {
            init: init
        };
    }

)();

$(UserService.init);
